import { businessWorkspaces, selectedBusinessWorkspace } from './business-workspaces';

export function BusinessWorkspaceSelector() {
  const choices = businessWorkspaces();
  if (!choices.length) return null;
  const selected = selectedBusinessWorkspace();
  return (
    <section
      className="portal-card"
      aria-label="业务数据工作区"
      style={{ padding: '12px 20px', marginBottom: 12 }}
    >
      <label>
        数据工作区{' '}
        <select
          aria-label="数据工作区"
          value={selected?.id}
          onChange={(event) => {
            const choice = choices.find((w) => w.id === event.target.value);
            if (!choice) return;
            const url = new URL(window.location.href);
            url.searchParams.set('dataWorkspace', choice.id);
            url.searchParams.set('synLive', '1');
            for (const [name, enabled] of [
              ['synMedia', choice.media],
              ['synAssessment', choice.assessment],
              ['synMonitoring', choice.equipment],
            ] as const) {
              if (enabled) url.searchParams.set(name, '1');
              else url.searchParams.delete(name);
            }
            window.location.assign(url.href);
          }}
        >
          {choices.map((choice) => (
            <option key={choice.id} value={choice.id}>
              {choice.label}
            </option>
          ))}
        </select>
      </label>
      <small style={{ display: 'block', marginTop: 6 }}>
        新业务使用统一业务档案；历史档案保留原编号和审核记录，切换后需重新登录。
      </small>
    </section>
  );
}
